export const mergeFinalPlayersWithRatings = (sortedPlayers, allRatingUpdates) => {
  return sortedPlayers.map((player) => {
    const update = allRatingUpdates.find((candidate) => candidate.username === player.name);

    if (!update) {
      return player;
    }

    return {
      ...player,
      ratingChange: update.change,
      rawRatingChange: update.rawChange ?? update.change,
      newRating: update.newRating,
      aiControlledMoves: update.aiControlledMoves ?? player.aiControlledMoves ?? 0,
      totalSeatMoves: update.totalSeatMoves ?? player.totalSeatMoves ?? 0,
    };
  });
};